import { ApplicantAccountingFormulaType } from "@/src/types/officeAccounting";

export type OfficeAccountingFormulaCurrency = "USD" | "EUR";

export type OfficeAccountingFormulaColumnConfig = {
  type: ApplicantAccountingFormulaType;
  currency: OfficeAccountingFormulaCurrency;
};

/**
 * Office Accounting columns edited via CustomCalculatePopUp
 * (Preparatory Department → Nostrification).
 */
export const OFFICE_ACCOUNTING_FORMULA_COLUMN_CONFIG: Record<string, OfficeAccountingFormulaColumnConfig> = {
  preparatoryDepartment: { type: "PreparatoryDepartment", currency: "USD" },
  costFirstSemester: { type: "CostOf1Semester", currency: "USD" },
  costSecondSemester: { type: "CostOf2Semester", currency: "USD" },
  costThirdSemester: { type: "CostOf3Semester", currency: "USD" },
  costFouthSemester: { type: "CostOf4Semester", currency: "USD" },
  costFifthSemester: { type: "CostOf5Semester", currency: "USD" },
  costSixthSemester: { type: "CostOf6Semester", currency: "USD" },
  costSeventhSemester: { type: "CostOf7Semester", currency: "USD" },
  costEighthSemester: { type: "CostOf8Semester", currency: "USD" },
  costNinthSemester: { type: "CostOf9Semester", currency: "USD" },
  costTenthSemester: { type: "CostOf10Semester", currency: "USD" },
  costEleventhSemester: { type: "CostOf11Semester", currency: "USD" },
  costTwelfthSemester: { type: "CostOf12Semester", currency: "USD" },
  pgPhdCostFirstSemester: { type: "CostPhD1Semester", currency: "USD" },
  pgPhdCostSecondSemester: { type: "CostPhD2Semester", currency: "USD" },
  pgPhdCostThirdSemester: { type: "CostPhD3Semester", currency: "USD" },
  pgPhdCostFourthSemester: { type: "CostPhD4Semester", currency: "USD" },
  pgPhdCostFifthSemester: { type: "CostPhD5Semester", currency: "USD" },
  pgPhdCostSixthSemester: { type: "CostPhD6Semester", currency: "USD" },
  otherExpenses: { type: "OtherExpenses", currency: "USD" },
  transfer: { type: "Transfer", currency: "USD" },
  insurance: { type: "Insurance", currency: "USD" },
  admissionFee: { type: "AdmissionFee", currency: "USD" },
  temporaryResidencePermission: { type: "TemporaryResidencePermission", currency: "USD" },
  hostelAccommodation: { type: "HostelAccommodation", currency: "USD" },
  paymentForMissedClasses: { type: "PaymentforMissedClasses", currency: "EUR" },
  nostrification: { type: "Nostrification", currency: "EUR" },
};

export const OFFICE_ACCOUNTING_FORMULA_COLUMN_IDS = Object.keys(OFFICE_ACCOUNTING_FORMULA_COLUMN_CONFIG);

export const isOfficeAccountingFormulaColumn = (columnId: string): boolean =>
  columnId in OFFICE_ACCOUNTING_FORMULA_COLUMN_CONFIG;

export const getOfficeAccountingFormulaColumnConfig = (
  columnId: string,
): OfficeAccountingFormulaColumnConfig | null => OFFICE_ACCOUNTING_FORMULA_COLUMN_CONFIG[columnId] ?? null;

/** All API formula type strings used by Office Accounting formula columns. */
export const OFFICE_ACCOUNTING_FORMULA_TYPES: readonly ApplicantAccountingFormulaType[] = Array.from(
  new Set(Object.values(OFFICE_ACCOUNTING_FORMULA_COLUMN_CONFIG).map((item) => item.type)),
);
